import styles from "./LoyaltyPointsHowItWorks.module.scss";
import { useTranslation } from "react-i18next";
import howItWorks from "../../../../assets/images/loyalty/how-it-works.png";
import { useGetLoyaltyExchangesQuery } from "../../../../api/queries/useGetLoyaltyExchangesQuery";

const LoyaltyPointsHowItWorks = () => {
  const { t } = useTranslation();
  const { data: exchanges = [] } = useGetLoyaltyExchangesQuery();

  return (
    <div className={styles.container}>
      <h2>{t("HowItWorks")}</h2>
      <div className={styles.box}>
        <img src={howItWorks} alt={"how it works"} />
        <p className={styles.text}>{t("ForEveryYouSpendYouGetCredits")}</p>
        <ul className={styles.list}>
          <li className={`${styles.row} ${styles.main}`}>
            <p>{t("Points")}</p>
            <p>{t("Credits")}</p>
          </li>
          {exchanges.map((el) => {
            return (
              <li key={el.id} className={styles.row}>
                <p>{el.numberOfPoints}</p>
                <p>{el.userReceive}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default LoyaltyPointsHowItWorks;
